import { render } from "./SelectQuestion.vue?vue&type=template&id=38a53d0b"
import script from "./SelectQuestion.vue?vue&type=script&lang=js"
export * from "./SelectQuestion.vue?vue&type=script&lang=js"

import exportComponent from "/Users/YuyiiChiMila/Company/GAME-MAKRO/outlier-p002/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__